import { FinanceLabField } from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";

export const FINANCE_API_METRIC_LIST = [
    AccountLabel.REVENUES,
    AccountLabel.GROSS_MARGIN,
    AccountLabel.EBITDA,
    AccountLabel.EBITDA_MARGIN,
    AccountLabel.NET_INCOME,
    AccountLabel.ASSETS,
    AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
    AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES,
    AccountLabel.CURRENT_ASSETS_NET_INVENTORY,
    AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    AccountLabel.LIABILITIES,
    AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    AccountLabel.CURRENT_LIABILITIES_DEBT,
];

export const FINANCE_LAB_METRIC_LIST = [
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY,
];
